import { ReactNode } from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { FullScreenModal, type FullScreenModalProps } from '@/components/shared/FullScreenModal';

type ModalBaseProps = Pick<
  FullScreenModalProps,
  | 'open'
  | 'onClose'
  | 'title'
  | 'subTitle'
  | 'breadcrumbs'
  | 'headerActions'
  | 'closeLabel'
  | 'allowBackdropClose'
  | 'initialFocusRef'
  | 'footer'
  | 'disableFocusTrap'
  | 'closeButton'
>;

export interface WorkflowModalLayoutProps extends ModalBaseProps {
  plannerTitle: string;
  plannerToolbar?: ReactNode;
  plannerContent: ReactNode;
  detailTitle?: string;
  detailContent?: ReactNode;
  sidebarTitle: string;
  sidebarContent: ReactNode;
}

export const WorkflowModalLayout = ({
  plannerTitle,
  plannerToolbar,
  plannerContent,
  detailTitle,
  detailContent,
  sidebarTitle,
  sidebarContent,
  ...modalProps
}: WorkflowModalLayoutProps) => (
  <FullScreenModal
    {...modalProps}
    sidebar={
      <Stack spacing={3} component="section">
        <Box>
          <Typography variant="h6" component="h3">
            {sidebarTitle}
          </Typography>
        </Box>
        {sidebarContent}
      </Stack>
    }
  >
    <Stack spacing={3} component="section" sx={{ height: '100%' }}>
      <Box>
        <Typography variant="h6" component="h3" sx={{ mb: 1 }}>
          {plannerTitle}
        </Typography>
        {plannerToolbar ? <Box>{plannerToolbar}</Box> : null}
      </Box>

      <Box sx={{ flex: 1, minHeight: 0 }}>{plannerContent}</Box>

      {detailContent ? (
        <Box>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="subtitle1" component="h4" sx={{ mb: 1 }}>
            {detailTitle ?? 'Nomenclature detail'}
          </Typography>
          {detailContent}
        </Box>
      ) : null}
    </Stack>
  </FullScreenModal>
);
